document.addEventListener('turbolinks:load', function () {
    if ($('.hud_trip_reports.new, .hud_trip_reports.create, .hud_trip_reports.edit, .hud_trip_reports.update').length === 0) {
        return false
    }

    processStep();

    function processStep() {
        $('.previous-step-btn').on('click', function (e) {
            e.preventDefault();

            var targetId = $(this).data("target")
            submitForm(targetId)
            window.scrollTo(0, 0)
        });

        $('.next-step-btn').on('click', function (e) {
            e.preventDefault();

            var targetId = $(this).data("target")
            submitForm(targetId)
            window.scrollTo(0, 0)
        });

        $('.modal-save-btn').on('click', function (e) {
            e.preventDefault();

            var targetId = $(this).data("target")
            submitForm(targetId)
            $('html, body').animate({ scrollTop: $(document).height() }, 'slow')
        });

        $('.saveHudReport').on('click', function (e) {
            e.preventDefault();
            $('#section').val($('.tab-pane.fade.active.show').attr('id').slice(2));
            submitHudForm();
        });

        $('.submitHudReport').on('click', function (e) {
            e.preventDefault();
            $('#section').val($('.tab-pane.fade.active.show').attr('id').slice(2));
            $('#complete_report').val(true);
            submitHudForm();
        });

        $('#v-organization-form-tab .form-tab').on('click', function (e) {
            e.preventDefault();

            var targetId = $(this).data("target")
            submitForm(targetId)
            window.scrollTo(0, 0)
        });
    }

    function submitForm(targetId) {
        assignFormValue(targetId)
        submitHudForm()
    }

    function assignFormValue(targetId) {
        $('#next_tab_id').val(targetId);
        $('#section').val($('.tab-pane.fade.active.show').attr('id').slice(2));
    }

    function submitHudForm() {
        let form = document.querySelector('#new-hud-form');

        let isValid = true;
        const inputs = form.querySelectorAll('input');
        for (const input of inputs) {
            let parentDiv = $(input).parent();
            $(parentDiv).find('.error-message').remove();
            if (!input.checkValidity()) {
                input.reportValidity();
                isValid = false;

                let errorMessage = $(input).attr('data-error-message')
                if (errorMessage) {
                    let errorElement = $('<div class="error-message text-danger small mt-1">' + errorMessage + '</div>');
                    $(parentDiv).append(errorElement);
                }
                break;
            }
        }

        if (!isValid) {
            return;
        }

        // Add submit event listener to show loader only when form is actually submitted
        form.addEventListener('submit', function() {
            // Rack caps multipart file parts at 128 and counts empty file inputs too, so a report
            // with many images fails before reaching Rails. Only post file inputs that hold a file.
            form.querySelectorAll('input[type="file"]').forEach(function (fileInput) {
                if (fileInput.files.length === 0) fileInput.disabled = true;
            });
            showLoader();
        });

        let button = document.createElement('input');
        button.style.display = 'none';
        button.type = 'submit';
        form.appendChild(button).click();
        form.removeChild(button);
    }

    function showLoader() {
        $('.loading-spinner').show();
        $('body').css({
            pointerEvents: "none"
        })
    }
});